import { render, staticRenderFns } from "./choosepeol.vue?vue&type=template&id=56bb79ac&scoped=true"
import script from "./choosepeol.vue?vue&type=script&lang=js"
export * from "./choosepeol.vue?vue&type=script&lang=js"
import style0 from "./choosepeol.vue?vue&type=style&index=0&id=56bb79ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bb79ac",
  null
  
)

export default component.exports